import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Margaret, 78",
    location: "Norwood",
    text:
      "He sat with me for nearly two hours and never once made me feel silly. My iPad finally makes sense, and I can video call my grandchildren in Perth.",
  },
  {
    name: "Ron & Beverley",
    location: "Glenelg",
    text:
      "A scammer almost got us. We rang and he talked us through what to do step by step. Lovely young bloke. Worth every cent.",
  },
  {
    name: "Joan, 82",
    location: "Modbury",
    text:
      "My printer has been a mystery for two years. He fixed it in twenty minutes and wrote me a little cheat-sheet I can keep by the desk.",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-20 md:py-24 bg-[#FFFFFF]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <p className="text-base md:text-lg font-semibold text-[#6BAF3C] uppercase tracking-wide">Kind words</p>
          <h2 className="mt-3 font-[Work_Sans] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F2E52]">
            From the lovely folks I’ve helped.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white border border-[#DCE4EC] rounded-2xl p-6 md:p-7 flex flex-col gap-4"
            >
              <Quote className="w-8 h-8 text-[#0F2E52]" strokeWidth={2.2} />
              <blockquote className="text-lg text-[#1E3A5F] leading-relaxed">
                “{r.text}”
              </blockquote>
              <div className="flex items-center gap-1 mt-auto">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-5 h-5 fill-[#0F2E52] text-[#0F2E52]" />
                ))}
              </div>
              <figcaption className="text-base">
                <span className="font-[Work_Sans] font-semibold text-[#0F2E52]">{r.name}</span>
                <span className="text-[#475569]"> · {r.location}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
